module.exports = __webpack_public_path__ + "img/aidtools_process.26d3d570.png";